/**
 * Created by tomers on 6/14/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var StringFormats = require("utils/StringFormats");

    var NO_LOBS_VALUE = "-1";
    var NO_SKILLS_VALUE = "-1";


    var UsersGridModel = {};
    var EMPTY_FILTERS = {
        "groups": [],
        "searchStr": ""
    };

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        UsersGridModel = BaseModel.extend({
            NO_LOBS_VALUE: NO_LOBS_VALUE,
            NO_SKILLS_VALUE: NO_SKILLS_VALUE,
            defaults: {
                filters: {
                    "groups": [],
                    "skills": [],
                    "roles": [],
                    "profiles": [],
                    "userType": [],
                    "lobs": [],
                    "searchStr": ""
                },
                comparators: {
                    "displayName": "displayName",
                    "userTypeId": "userTypeId",
                    "nickName": "nickName",
                    "loginName": "loginName",
                    "permissionGroup": "permissionGroup"
                }
            },
            name: "UsersGridModel",
            pluck: function (model) {
                return true;
            },
            setFilterValue: function (filterName, filterValue) {
                if (!_.isUndefined(this.get("filters." + filterName))) {
                    this.set("filters." + filterName, filterValue);
                }
            },
            getFilterValue: function (filterName) {
                return this.get("filters." + filterName);
            },
            getFilters: function () {
                return this.get("filters");
            },
            setFilters: function (filters) {
                this.set("filters", filters);
            },
            resetFilters: function () {
                this.setFilters(EMPTY_FILTERS);
            },
            setPermissionGroups: function (permissionGroupsCollection) {
                this.permissionGroupsCollection = permissionGroupsCollection;
            },
            setProfiles: function (profilesCollection) {
                this.profilesCollection = profilesCollection;
            },
            setAvailableRoles: function(availableRoles) {
                this.availableRoles = availableRoles || [];
            },
            setAgentGroups: function(agentGroupsCollection) {
                this.agentGroups = agentGroupsCollection;
            },
            setSearchString: function (searchStr) {
                this.searchRegExp = StringFormats.getRegExpForSearch(searchStr);
                this.setFilterValue("searchStr", searchStr);
            },
            getSearchString: function () {
                return this.getFilterValue("searchStr");
            },

            predicate: function (model) {
                var dataManager = LEUserManagement.getDataManager();
                var modelIsInSelection = true;
                var passFilter;

                var userLobs = model.getLobs();

                if (!_.isEmpty(this.getSearchString())) {
                    modelIsInSelection = passFilter = this._predicate4Search(model);
                }

                if (LE.sessionManager.hasProfilesFeature()) {
                    var privileges = {viewAll: LEUserManagement.hasAllUsersViewPrivilege(), editAgent: LEUserManagement.hasAgentUserEditPrivilege(), editAgentManager: LEUserManagement.hasAgentManagerUserEditPrivilege()};
                    var groupsUnderLoggedInUser = dataManager.getData(dataManager.getEntities().AGENT_MANAGER_MODEL).getGroups();
                    var profilesCollection = this.profilesCollection;
                    passFilter = model.isViewableForLoggedInUser(privileges, groupsUnderLoggedInUser, profilesCollection);
                    modelIsInSelection = modelIsInSelection && passFilter;

                    // if lob feature enabled and the user is admin (has viewAll permission) - pre filter - filter always by user lobIds - no matter what is set in the filters attribute
                    // if the user is UMBAM and doesn't have viewAll permission we will show him the user regardless of lobs
                    if (LE.sessionManager.hasEntitiesTaggingByLobFeature() && privileges.viewAll) {
                        passFilter = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isLobAllowedForUser, userLobs);
                        modelIsInSelection = modelIsInSelection && passFilter;
                    }
                }

                var filteredLobs = this.get("filters.lobs");
                if (!_.isEmpty(filteredLobs)) {
                    passFilter = false;
                    _.each(filteredLobs, function (filteredLobId) {
                        if (_.intersection(userLobs, filteredLobs).length > 0 || (_.isEmpty(userLobs) && (filteredLobId === NO_LOBS_VALUE))) { // in case of "unassigned", the lobId in filters will be NO_LOBS_VALUE and the user lobs is empty
                            passFilter = true;
                        }
                    });
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                //check if any of the model groups is in selection:
                var groupsFilter = this.getFilterValue("groups");
                if (!_.isEmpty(groupsFilter)) {
                    passFilter = _.some(groupsFilter, function (group) {
                        return _.some(model.getGroups(dataManager.getAgentGroupsCollection()), function (userGroup) {
                            return userGroup.name === group;
                        });
                    });
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                //check if any of the model skills is in selection:
                var skillsFilter = this.getFilterValue("skills");
                var skillIds = model.getSkills();
                if (!_.isEmpty(skillsFilter) ) {
                    passFilter = _.some(skillsFilter, function (skillIdInfilter) {
                        var isUnassigned = (skillIdInfilter === NO_SKILLS_VALUE) && _.isEmpty(model.getSkills());
                        return isUnassigned || _.some(model.getSkills(), function (skillId) {
                            return skillId === skillIdInfilter;
                        });
                    });
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                if (LE.sessionManager.hasProfilesFeature()) {
                    //check if model name is in selection:
                    var rolesFilter = this.get("filters.roles");
                    var profileIds = model.getProfiles();
                    if (!_.isEmpty(rolesFilter) && !_.isEmpty(profileIds)) {
                        var profiles = this.profilesCollection.filter(function (profile) {
                            return -1 < profileIds.indexOf(profile.id);
                        });

                        passFilter = _.some(rolesFilter, function (id) {
                            var pass = _.some(profiles, function(profile) {
                                return profile.getRoleTypeId() === id;
                            });

                            return pass;
                        });

                        modelIsInSelection = modelIsInSelection && passFilter;
                    }

                    //check if model name is in selection:
                    var profilesFilter = this.get("filters.profiles");
                    if (!_.isEmpty(profilesFilter) && !_.isEmpty(profileIds)) {
                        passFilter = _.some(profilesFilter, function (id) {
                            var pass = _.some(profileIds, function (profileId) {
                                return profileId === id;
                            });

                            return pass;
                        });

                        modelIsInSelection = modelIsInSelection && passFilter;
                    }
                }

                if (LE.sessionManager.hasUserTypeBotFeature()){
                    var typesFiler = this.get("filters.userType");
                    if (!_.isEmpty(typesFiler)) {
                        passFilter = _.some(typesFiler, function (type) {
                            return model.getUserType() === type;
                        });
                        modelIsInSelection = modelIsInSelection && passFilter;
                    }

                }

                return modelIsInSelection;
            },

            _predicate4Search: function (userModel) {
                var dataManager = LEUserManagement.getDataManager();

                if (userModel.getDisplayName().search(this.searchRegExp) > -1 ||
                    userModel.getNickName().search(this.searchRegExp) > -1 ||
                    userModel.getLoginName().search(this.searchRegExp) > -1
                ) {
                    return true;
                }
                var i;
                var groups = userModel.getGroups(dataManager.getAgentGroupsCollection());
                if (groups) {
                    for (i = 0; i < groups.length; i++) {
                        if (groups[i].name.search(this.searchRegExp) > -1) {
                            return true;
                        }
                    }
                }

                var skillIds = userModel.getSkills();
                if (skillIds) {
                    for (i = 0; i < skillIds.length; i++) {
                        var skillName = LEUserManagement.getDataManager().getNameById(LEUserManagement.getDataManager().getEntities().SKILL, skillIds[i]);
                        if (skillName.search(this.searchRegExp) > -1) {
                            return true;
                        }
                    }
                }

                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    var lobIds = userModel.getLobs();
                    if (lobIds) {
                        for (i = 0; i < lobIds.length; i++) {
                            var lobName = LEUserManagement.getDataManager().getNameById(LEUserManagement.getDataManager().getEntities().LOB, lobIds[i]);
                            if (lobName.search(this.searchRegExp) > -1) {
                                return true;
                            }
                        }
                    }
                }

                //should be the last clause in the search as the implementation here both return false and true and dont carry on ...
                if (LE.sessionManager.hasProfilesFeature()) {
                    if (LE.sessionManager.hasUserTypeBotFeature()){
                        var types = userModel.USER_TYPES;
                        var typeName = LE.translator.translate("LEUserManagement.userEdit.userType." + userModel.getUserTypeKey());
                        if(typeName.search(this.searchRegExp) > -1) {
                            return true;
                        }
                    }
                    var profileIds = userModel.getProfiles();
                    if (!_.isEmpty(profileIds)) {
                        return 0 < this.profilesCollection.filter(function (profile) {
                                var matchName;
                                var matchRole;
                                var exists = (-1 < profileIds.indexOf(profile.id));
                                if (exists) {
                                    matchName = (-1 < profile.get("name").search(this.searchRegExp));

                                    if (!matchName) {
                                        matchRole = (-1 < LE.translator.translate(this.availableRoles[profile.getRoleTypeId()]).search(this.searchRegExp));
                                    }

                                    if (matchName || matchRole) {
                                        return true;
                                    }
                                }
                        }.bind(this)).length;
                    }
                }
                else {
                    var permissionGroupId = userModel.getPermissionGroup();
                    if (this.permissionGroupsCollection.get(permissionGroupId)) {
                        var translatedPermission = this.permissionGroupsCollection.get(permissionGroupId).getTranslatedName();
                        if (translatedPermission.search(this.searchRegExp) > -1) {
                            return true;
                        }
                    }
                }



                return false;
            },

        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UsersGridModel;
});
